import { render, staticRenderFns } from "./CourseProfile.vue?vue&type=template&id=93caec6e&"
import script from "./CourseProfile.vue?vue&type=script&lang=js&"
export * from "./CourseProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports